'use strict';

let $pageContainer, $detailsContainer;

export function loadBillingCentreSettings(billingCentreID) {
    //$detailsContainer.html('Billing Centre ID: ' + billingCentreID);

    var detailsURL = '/pages/settings_billing_centre_detailed.cfm?' + $.param({
        billingCentreID: billingCentreID,
    });

    $.ajax({
        type: 'GET',
        url: detailsURL,
        dataType: 'html',
        cache: false,
        success: function (data) {
            $detailsContainer.html(data);
        },
        error: function (data) {
            console.log(data);
        },
    });

}

export function setupBinds() {
    // Save current company value when in focus if use decides to not change
    // Might be better way to do this.
    var billingCentreLastSel = $pageContainer.find('[name="controlLevel"]').val();

    // Change Company
    $pageContainer.find('[name="billingCentre"]').bind('change', function (event) {
        event.preventDefault();

        var billingCentreID = $(this).val();

        if (billingCentreChanged) {

            $(this).val(billingCentreLastSel);

            confirmationPopup({
                contents: 'Unsaved changes - Are you sure you want to leave?',
                yes: function (){
                    loadBillingCentreSettings(billingCentreID);
                    $pageContainer.find('[name="billingCentre"]').val(billingCentreID);
                    billingCentreChanged = false;
                    settingsPageCheckSaveIcon();
                },
            });

        } else {
            loadBillingCentreSettings(billingCentreID);
            billingCentreLastSel = $(this).val();
        }
    });
}

export function initDetailsPage() {
    $('button').button();
}

export function init(options) {

    if (!options) { options = {}; }
    if (!options.pageContainer) {
        options.pageContainer = '#settings-billing-centres-container';
    }
    if (!options.detailsContainerSelector) {
        options.detailsContainerSelector = '#settings-billing-centre-details';
    }

    // Save Key Objects
    $pageContainer = $(options.pageContainer);
    $detailsContainer = $(options.detailsContainerSelector);

    // Setup Binds
    setupBinds();

}

if (window.EQLAPP === undefined) {
    window.EQLAPP = {};
}

if (window.EQLAPP) {
    window.EQLAPP.BILLINGCENTRE = window.EQLAPP.BILLINGCENTRE || {};
    window.EQLAPP.BILLINGCENTRE.init = init;
    window.EQLAPP.BILLINGCENTRE.initDetailsPage = initDetailsPage;
    window.EQLAPP.BILLINGCENTRE.loadBillingCentreSettings = loadBillingCentreSettings;
}